<template>
    <div>
        <o-field label="Control Number *" :type="fieldType('control_number')" :message="getError('control_number')">
            <o-input placeholder="Control Number" v-model="form.control_number"/>
        </o-field>

        <o-field label="Applicant *" :type="fieldType('applicant_id')" :message="getError('applicant_id')">
            <o-select placeholder="Select an Applicant" v-model="form.applicant_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in determinationStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        data () {
            return {
                form: {
                    control_number: null,
                    applicant_id: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                determinationStatuses: 'determinationStatuses',
                applicants: 'contacts'
            })
        }
    }
</script>
